import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

import styled, { keyframes } from 'styled-components';
import { RGB_2_ARRAY } from '../../lib/ep';

const descentAdv = (r, g, b) => keyframes`
	0% {
		width:100%;
		background-color:rgba(${r}, ${g}, ${b}, 0.8);
	}
	89% {
		background-color:rgba(${r}, ${g}, ${b}, 0.8);
	}
	90% {
		background-color:rgba(${r}, ${g}, ${b}, 1);
	}
	100% {
		width:0%;
		background-color:rgba(${r}, ${g}, ${b}, 1);
	}
`;

const descentAdvWidth = () => keyframes`
	0% {
		width:100%;
	}
	100% {
		width:0%;
	}
`;

const BarOnlyWidth = styled.div`
	animation:${(props) => descentAdvWidth()} ${(props) => props?.time ?? 60}s linear;
`;

const Bar = styled.div`
	animation:${(props) => descentAdv(props.color[0], props.color[1], props.color[2])} ${(props) => props?.time ?? 60}s linear;
`;

const TimeBar = forwardRef((props, ref) => {
	const enable_animation = props?.enable_animation ?? true;
	const seconds = parseInt(props?.seconds ?? '10');

	const timer = useRef(null);
	const start = useRef();

	useEffect(() => {
		if(enable_animation === false) return;

		start.current = Date.now();

		timer.current = setTimeout(() => {
			if(props.onEnd != undefined) props.onEnd();
		}, (seconds * 1000));

		if(props.onStart) props.onStart();

		return () => {
			clearInterval(timer.current);
		}
	}, []);

	useImperativeHandle(ref, () => ({
		getTimeUp() {
			return seconds - (Date.now() - start.current) / 1000;
		},
	}));

	const color_bar = props?.color ?? 'rgba(215, 35, 60, 1)';

	if(!enable_animation) {
		return (
			<div class="countdown_bar">
				<div
					class="bar"
					style={(color_bar !== false) ? { background:color_bar } : null}
				/>
			</div>
		)
	}

	if(color_bar !== false) {
		return (
			<div class="countdown_bar">
				<Bar
					class="bar"
					time={seconds}
					color={RGB_2_ARRAY(color_bar)}
				/>
			</div>
		)
	}

	return (
		<div class="countdown_bar">
			<BarOnlyWidth
				class="bar"
				time={seconds}
			/>
		</div>
	)
});

export default TimeBar;